import React, { useContext } from "react";
import { Button } from "components/ui/button";
import { IntlContext } from "context";

type OfferPanelFooterProps = {
    onClose: () => void;
    submitting: boolean;
};

const OfferPanelFooter: React.FC<OfferPanelFooterProps> = ({ onClose, submitting }) => {
    const intl = useContext(IntlContext);

    return (
        <div className="border-t border-slate-100 bg-white px-6 py-6">
            <div className="grid grid-cols-2 gap-3">
                <Button type="button" variant="outline" className="h-12 rounded-[10px] shadow-none" onClick={onClose}>
                    {intl.formatMessage("booking.messages.offer.cancel")}
                </Button>
                <Button
                    type="submit"
                    className="h-12 rounded-[10px] bg-emerald-600 shadow-sm hover:bg-emerald-700"
                    disabled={submitting}
                >
                    {submitting
                        ? intl.formatMessage("booking.messages.offer.sending")
                        : intl.formatMessage("booking.messages.offer.submit")}
                </Button>
            </div>
        </div>
    );
};

export default OfferPanelFooter;
